import { render, staticRenderFns } from "./InputPad.vue?vue&type=template&id=e8a3928a&scoped=true&"
import script from "./InputPad.vue?vue&type=script&lang=ts&"
export * from "./InputPad.vue?vue&type=script&lang=ts&"
import style0 from "./InputPad.vue?vue&type=style&index=0&id=e8a3928a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a3928a",
  null
  
)

export default component.exports